export default "__VITE_ASSET__aweOcuDp__"